import {Box} from "@mui/material";
import React from "react";

const NoTicketsError: React.FC = () => {
    return (
        <Box
            sx={{
                height: {
                    xs: "calc(100vh - 453px)",
                    sm: "calc(100vh - 322px)",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontFamily: "Graphik, Arial, sans-serif",
                },
            }}
        >
            No Tickets Found
        </Box>
    );
};

export default NoTicketsError;
